import { useRoleInfo } from "layouts/role-info/_context/RoleinfoContext";
import SearchTableUsers from "views/roles/role-info/users/components/SearchTableUsers";
import Card from "components/card";

const UsersDataTable = () => {
  const { roleInfo } = useRoleInfo();
  return (
    <Card extra={"w-full h-full mt-3"}>
      <SearchTableUsers tableData={roleInfo?.members || []} />
    </Card>
  );
};

export default UsersDataTable;
